import { unref as _unref, createVNode as _createVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "index"
};
const _hoisted_2 = {
  class: "form"
};
const _hoisted_3 = ["inputmode", "maxlength", "placeholder"];
const _hoisted_4 = ["inputmode", "maxlength", "placeholder"];
const _hoisted_5 = {
  class: "form-input icon5 verification"
};
const _hoisted_6 = ["disabled"];
const _hoisted_7 = {
  class: "hint"
};
import CustomBar from "@/components/customBar";
import { usebaseRouter } from "@/utils/hooks";
import { ref } from "vue";
import { useSendCode } from "@/utils/hooks";
import { change_paypasswd, change_passwd, send_vcode } from "@/api/index";
import { useStore } from "@/store/index";

import { showToast } from 'vant/es';
import 'vant/es/toast/style/index';
export default {
  __name: 'index',
  setup(__props) {
    const {
      back,
      getQuery
    } = usebaseRouter();
    const store = useStore();
    const {
      type
    } = getQuery();
    const maxlength = type == 1 ? 12 : 6;
    const inputmode = type == 1 ? 'text' : 'tel';
    const params = ref({
      newPwd: '',
      confirmPwd: '',
      vcode: ''
    });
    const {
      send,
      disabled,
      sendBtnText
    } = useSendCode({
      countDownCount: 60,
      fail: msg => {
        // 手机号验证失败
        showToast(msg);
      },
      request: async mobile => {
        try {
          await send_vcode({
            mobile: mobile
          });
          showToast('验证码发送成功，请注意查收');
        } catch (error) {
          showToast('验证码发送失败，请稍后重试');
        }
      }
    });
    const handleClickSend = () => send(store.userInfo.mobile);
    const submit = () => {
      if (!params.value.newPwd) return showToast('请输入新密码');
      if (!params.value.confirmPwd) return showToast('请输入确认密码');
      if (params.value.newPwd != params.value.confirmPwd) return showToast('两次密码不一致');
      if (!params.value.vcode) return showToast('请输入验证码');
      let p = {};
      if (type == 1) {
        p = {
          passwd: params.value.newPwd,
          passwdConfirm: params.value.confirmPwd,
          vcode: params.value.vcode
        };
      } else {
        p = {
          payPasswd: params.value.newPwd,
          passwdConfirm: params.value.confirmPwd,
          vcode: params.value.vcode
        };
      }
      const api = type == 1 ? change_passwd : change_paypasswd;
      api(p).then(() => {
        showToast(type == 1 ? '登录密码修改成功' : '支付密码修改成功');
        back();
      });
    };
    return (_ctx, _cache) => {
      const _component_van_button = _resolveComponent("van-button");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_unref(CustomBar), {
        title: _unref(type) == 1 ? '修改登录密码' : '修改支付密码'
      }, null, 8, ["title"]), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_withDirectives(_createElementVNode("input", {
        class: "form-input icon4",
        type: "password",
        inputmode: _unref(inputmode),
        maxlength: _unref(maxlength),
        placeholder: `请输入新密码${_unref(type) == 1 ? '（至少6位）' : '（6位纯数字）'}`,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => params.value.newPwd = $event)
      }, null, 8, _hoisted_3), [[_vModelText, params.value.newPwd]]), _withDirectives(_createElementVNode("input", {
        class: "form-input icon4",
        type: "password",
        inputmode: _unref(inputmode),
        maxlength: _unref(maxlength),
        placeholder: `请确认新密码${_unref(type) == 1 ? '（至少6位）' : '（6位纯数字）'}`,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => params.value.confirmPwd = $event)
      }, null, 8, _hoisted_4), [[_vModelText, params.value.confirmPwd]]), _createElementVNode("div", _hoisted_5, [_withDirectives(_createElementVNode("input", {
        class: "input",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => params.value.vcode = $event),
        type: "tel",
        maxlength: "4",
        placeholder: "验证码"
      }, null, 512), [[_vModelText, params.value.vcode]]), _createElementVNode("div", {
        class: "text",
        onClick: handleClickSend,
        disabled: _unref(disabled)
      }, _toDisplayString(_unref(sendBtnText)), 9, _hoisted_6)]), _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(type) == 1 ? '密码不得少于6位' : '支付密码为6位纯数字'), 1), _createVNode(_component_van_button, {
        type: "primary",
        large: "",
        round: "",
        block: "",
        class: "savebtn",
        onClick: submit
      }, {
        default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode("完成修改")])),
        _: 1
      })])])], 64);
    };
  }
};